import { render, staticRenderFns } from "./DateTimeConfig.vue?vue&type=template&id=23c1e872&scoped=true"
import script from "./DateTimeConfig.vue?vue&type=script&lang=js"
export * from "./DateTimeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c1e872",
  null
  
)

export default component.exports